import Link from '~/shared/components/link';
import { getDate, getUrl } from '~/shared/helpers/string-helpers';
import type { PostType } from '~/shared/types/post-type';

import './single-item.scss';

import noImage from '~/assets/no-image.webp';

type SingleItemComponentPropsType = {
  pageToGo: string;
  data: PostType;
};

const SingleItem = ({ pageToGo, data }: SingleItemComponentPropsType) => {
  const link = getUrl({ link: pageToGo, alias: data?.alias });

  return (
    <div
      className="single-item"
      style={{
        backgroundImage: `url("${data?.image?.path ?? noImage.src}")`,
      }}
    >
      <div className="single-item__overlay" />
      <div className="single-item__container-wrapper">
        <div className="single-item__content">
          {link ? (
            <Link href={link} className="single-item__title">
              {data?.title}
            </Link>
          ) : data?.title ? (
            <div className="single-item__title">{data?.title}</div>
          ) : data?.name ? (
            <div className="single-item__title-small">{data?.name}</div>
          ) : (
            ' '
          )}
          {data?.createdAt && <span className="single-item__created-at">{getDate(data.createdAt)}</span>}
        </div>
      </div>
    </div>
  );
};

export default SingleItem;
